<template>
  <div class="auth-wrapper">
    <b-spinner
      variant="primary"
      label="Text Centered"
    />
  </div>
</template>
<script>
export default {
  name: 'SettingUser',
  created() {
    this.$store
      .dispatch('users/fetchUser')
      .then(res => {
        if (res.data.result.defaultOrganizationId !== null) {
          this.$store.commit(
            'app/SET_ORGANIZATION_ID',
            res.data.result.defaultOrganizationId,
          )
        } else {
          this.$router.push({ name: 'organization', query: this.$route.query })
          return
        }
        if (res.data.result.defaultProjectId !== null) {
          this.$store.commit(
            'app/SET_PROJECT_ID',
            res.data.result.defaultProjectId,
          )
        } else {
          this.$router.push({ name: 'project', params: { projectId: null }, query: this.$route.query })
          return
        }
        if (this.$route.params.nextRoute) {
          this.$router
            .push({ name: this.$route.params.nextRoute, query: this.$route.query })
            .catch(() => {})
        } else {
          this.$router.push({ name: 'distributions', query: this.$route.query }).catch(() => {})
        }
      })
      .catch(() => this.$router.push({ name: 'organization', query: this.$route.query }))
  },
}
</script>
<style lang="scss" scoped>
.auth-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
